import React from 'react';
import SmoothCollapse from 'react-smooth-collapse';

import styles from './FadeCollapse.module.scss';

interface Props {
  open: boolean;
  children: React.ReactNode;
}

const FadeCollapse: React.FC<Props> = ({ open, children }) => {
  return (
    <div data-testid="fade-collapse" className={`${styles.Outer} ${open ? styles.Visible : ''}`}>
      <SmoothCollapse allowOverflowWhenOpen expanded={open}>
        {children}
      </SmoothCollapse>
    </div>
  );
};

export default FadeCollapse;
